/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Stock_Warehouse_ScentingInputs */

const vi_tea_grade_stock_warehouse_scenting = /** @type {(inputs: Tea_Grade_Stock_Warehouse_ScentingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho lấy hương`)
};

/**

* @param {Tea_Grade_Stock_Warehouse_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_stock_warehouse_scenting = /** @type {((inputs?: Tea_Grade_Stock_Warehouse_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Stock_Warehouse_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_stock_warehouse_scenting(inputs)
});